import React from 'react';
import { useTranslation } from 'react-i18next';
import HelpBadge from './HelpBadge';

const MINUTE = 60 * 1000;

const runningColor = (ms) => {
  if (ms < 5 * MINUTE) return 'danger';
  if (ms < 15 * MINUTE) return 'warning';
  return 'success';
};

/**
 * The time the agent still has on a conversation, as timeLeft() in
 * config/aiConversationWindow.js reads it. Every state explains itself on
 * hover, the last one above all: it is the one that looks like a problem and
 * is not.
 */
const TimeLeftBadge = ({ id, value }) => {
  const { t } = useTranslation();
  const target = `timeLeft_${id}`;

  if (!value || value.state === 'unknown') return '-';

  if (value.state === 'running')
    return (
      <HelpBadge
        id={target}
        color={runningColor(value.ms)}
        help={t(
          'Minutes the agent still has before the lead goes back to the call center on its own',
        )}
      >
        {t('{{minutes}} min', { minutes: Math.ceil(value.ms / MINUTE) })}
      </HelpBadge>
    );

  if (value.state === 'extended')
    return (
      <HelpBadge
        id={target}
        color="info"
        help={t(
          'The time is over, but she wrote in the last five minutes: the agent keeps her until she stops writing',
        )}
      >
        {t('Writing')}
      </HelpBadge>
    );

  return (
    <HelpBadge
      id={target}
      color="secondary"
      help={t(
        'The time is over: the lead goes back to the operator queue on its own within two minutes. Nothing to do',
      )}
    >
      {t('Going back to the call center')}
    </HelpBadge>
  );
};

export default TimeLeftBadge;
